export const V1DocumentRevisionIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"] && input["ShifamedMessage"]["ListOfDocumentRevision"] !== undefined) {
        if (input["ShifamedMessage"]["ListOfDocumentRevision"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["ShifamedMessage"]["ListOfDocumentRevision"].Count;
        }

        let results = [];

        if ("DocumentRevision" in input["ShifamedMessage"]["ListOfDocumentRevision"]) {
            for (let i = 0; i < input["ShifamedMessage"]["ListOfDocumentRevision"]["DocumentRevision"].length; i++) {
                let documentRevision = input["ShifamedMessage"]["ListOfDocumentRevision"]["DocumentRevision"][i];

                let row: any = {};

                row.USID = documentRevision.USID;
                row.DocumentUSID = documentRevision.DocumentUSID;
                row.DocumentID = documentRevision.DocumentID;
                row.DocumentIDPlusRevision = documentRevision.DocumentIDPlusRevision;
                row.DocumentTypeUSID = documentRevision.DocumentTypeUSID;
                row.DocumentTypeGroup = documentRevision.DocumentTypeGroup;
                row.DocumentTypeAcronym = documentRevision.DocumentTypeAcronm;
                row.Version = documentRevision.Version;
                row.Description = documentRevision.Description;
                row.Name = documentRevision.Name;
                row.Status = documentRevision.Status;
                row.DisplayStatus = documentRevision.DisplayStatus;
                row.ParentEquipmentUSID = documentRevision.ParentEquipmentUSID;
                row.Revision = documentRevision.Revision;
                row.RevisionStage = documentRevision.RevisionStage;
                row.OwnerUSID = documentRevision.OwnerUSID;
                row.OwnerUserUSID = documentRevision.OwnerUserUSID;
                row.OwnerUserName = documentRevision.OwnerUserName;
                row.ApprovalRequestUSID = documentRevision.ApprovalRequestUSID;
                row.ApprovalRequestID = documentRevision.ApprovalRequestID;
                row.RevisionChangeType = documentRevision.RevisionChangeType;
                row.DeprecatedAt = documentRevision.DeprecatedAt;
                row.ReleasedAt = documentRevision.ReleasedAt;
                row.ObsoletedAt = documentRevision.ObsoletedAt;
                row.Retrain = documentRevision.Retrain;
                row.EnlilFormInput = documentRevision.EnlilFormInput;
                row.FormDocumentRevisionUSID = documentRevision.FormDocumentRevisionUSID;
                row.ExternalID = documentRevision.ExternalID;
                row.RenderHTML = documentRevision.RenderHTML;
                row.PDFUSID = documentRevision.PDFUSID;
                row.SubRevision = documentRevision.SubRevision;
                row.DisplayRevision = documentRevision.DisplayRevision;
                row.PreCalc = documentRevision.PreCalc;
                row.Schema = documentRevision.Schema;
                row.EquipmentStatus = documentRevision.EquipmentStatus;
                row.PurchaseOrderStatus = documentRevision.PurchaseOrderStatus;
                row.LotStatus = documentRevision.LotStatus;
                row.EffectiveDate = documentRevision.EffectiveDate;
                row.PrimaryAttachmentUSID = documentRevision.PrimaryAttachmentUSID;
                row.LastZipFileUpdate = documentRevision.LastZipFileUpdate;
                row.ApprovedAt = documentRevision.ApprovedAt;
                row.SearchableContent = documentRevision.SearchableContent;
                row.CreatedDatetime = documentRevision.CreatedDatetime;
                row.LastModifiedDatetime = documentRevision.LastModifiedDatetime;
                row.Keyword = documentRevision.Keyword;
                row.Realm = documentRevision.CompanyUSID;

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1ProjectPlanIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"] && input["ShifamedMessage"]["ListOfProjectPlan"] !== undefined) {
        if (input["ShifamedMessage"]["ListOfProjectPlan"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["ShifamedMessage"]["ListOfProjectPlan"].Count;
        }

        let results = [];

        if ("ProjectPlan" in input["ShifamedMessage"]["ListOfProjectPlan"]) {
            for (let i = 0; i < input["ShifamedMessage"]["ListOfProjectPlan"]["ProjectPlan"].length; i++) {
                let projectPlan = input["ShifamedMessage"]["ListOfProjectPlan"]["ProjectPlan"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = projectPlan.USID;
                row.ProjectPlanID = projectPlan.ProjectPlanID;
                row.Name = projectPlan.Name;
                row.ProjectPlanPhases = null;
                if (projectPlan.ListOfProjectPlanPhase !== undefined) {
                    row.ProjectPlanPhases = projectPlan.ListOfProjectPlanPhase.ProjectPlanPhase;
                }
                row.Status = projectPlan.Status;
                row.PrimaryPositionUSID = projectPlan.PrimaryPositionUSID;
                row.PrimaryPositionName = projectPlan.PrimaryPositionName;
                row.PrimaryPositionPrimaryEmployeeUSID = projectPlan.PrimaryPositionPrimaryEmployeeUSID;
                row.PrimaryPositionPrimaryUserName = projectPlan.PrimaryPositionPrimaryUserName;
                row.PrimaryUserGroupUSID = projectPlan.PrimaryUserGroupUSID;
                row.PrimaryUserGroupName = projectPlan.PrimaryUserGroupName;
                row.PrimaryUserGroupPrimaryEmployeeUSID = projectPlan.PrimaryUserGroupPrimaryEmployeeUSID;
                row.PrimaryUserGroupPrimaryUserName = projectPlan.PrimaryUserGroupPrimaryUserName;
                row.PrimaryWorkGroupUSID = projectPlan.PrimaryWorkGroupUSID;
                row.PrimaryWorkGroupName = projectPlan.PrimaryWorkGroupName;
                row.PrimaryWorkGroupPrimaryEmployeeUSID = projectPlan.PrimaryWorkGroupPrimaryEmployeeUSID;
                row.PrimaryWorkGroupPrimaryUserName = projectPlan.PrimaryWorkGroupPrimaryUserName;
                row.NumberOfDonePhases = projectPlan.NumberOfDonePhases;
                row.CreatedByUSID = projectPlan.CreatedByUSID;
                row.CreatedByUserUSID = projectPlan.CreatedByUserUSID;
                row.CreatedByUserEmail = projectPlan.CreatedByUserEmail;
                row.CreatedByUserName = projectPlan.CreatedByUserName;
                row.CompletedOnDatetime = projectPlan.CompletedOnDatetime;
                row.CreatedDatetime = projectPlan.CreatedDatetime;
                row.GlobalLastModifiedDatetime = projectPlan.GlobalLastModifiedDatetime;
                row.GlobalLastModifiedByUserUSID = projectPlan.GlobalLastModifiedByUserUSID;
                row.GlobalLastModifiedByUserEmail = projectPlan.GlobalLastModifiedByUserEmail;
                row.GlobalLastModifiedByUserName = projectPlan.GlobalLastModifiedByUserName;
                row.PlanToCopyUSID = null;
                row.PlanToCopyNewName = null;
                row.PlanToCopyNewProjectID = null;
                row.LastModifiedDatetime = projectPlan.LastModifiedDatetime;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }
    return output;
};

export const V1ProjectPlanAuditIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"] && input.ShifamedMessage["ListOfProjectPlan"] !== undefined) {
        if (input.ShifamedMessage["ListOfProjectPlan"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfProjectPlan"].Count;
        }

        let results: any[] = [];

        if ("ProjectPlan" in input.ShifamedMessage["ListOfProjectPlan"]) {
            for (let i = 0; i < input.ShifamedMessage["ListOfProjectPlan"]["ProjectPlan"].length; i++) {
                let projectPlan = input.ShifamedMessage["ListOfProjectPlan"]["ProjectPlan"][i];

                for (let j = 0; j < projectPlan["ListOfProjectMilestoneAuditHistory"]["ProjectMilestoneAuditHistory"].length; j++) {
                    let auditLog: any = projectPlan["ListOfProjectMilestoneAuditHistory"]["ProjectMilestoneAuditHistory"][j];

                    let row: any = {};

                    let unordered = JSON.parse(atob(auditLog.Change));
                    const ordered = Object.keys(unordered).sort().reduce(
                        (obj: any, key: string) => {
                            obj[key] = unordered[key];
                            return obj;
                        },
                        {}
                    );

                    row.RowSelected = false;
                    row.USID = auditLog.USID;
                    row.ModificationType = auditLog.ModificationType;
                    row.SerialNumberUSID = auditLog.SerialNumberUSID;
                    row.ProjectPlanUSID = auditLog.ProjectPlanUSID;
                    row.ProjectPlanName = auditLog.ProjectPlanName;
                    row.ProjectPlanPhaseUSID = auditLog.ProjectPlanPhaseUSID;
                    row.ProjectPlanPhaseName = auditLog.ProjectPlanPhaseName;
                    row.ProjectPlanPhaseMilestoneUSID = auditLog.ProjectPlanPhaseMilestoneUSID;
                    row.ProjectPlanPhaseMilestoneName = auditLog.ProjectPlanPhaseMilestoneName;
                    row.ProjectPlanPhaseMilestoneReferenceUSID = auditLog.ProjectPlanPhaseMilestoneReferenceUSID;
                    row.Change = ordered;
                    row.CreatedByUSID = auditLog.CreatedByUSID;
                    row.CreatedByName = auditLog.CreatedByName;
                    row.CreatedByEmail = auditLog.CreatedByEmail;
                    row.CreatedDatetime = auditLog.CreatedDatetime;
                    row.LastModifiedDatetime = auditLog.LastModifiedDatetime;
                    row.Action = null;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (projectPlan["ListOfProjectMilestoneAuditHistory"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = projectPlan["ListOfProjectMilestoneAuditHistory"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1ProjectMilestoneSessionIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"] && input["ShifamedMessage"]["ListOfProjectMilestoneSession"] !== undefined) {
        if (input["ShifamedMessage"]["ListOfProjectMilestoneSession"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["ShifamedMessage"]["ListOfProjectMilestoneSession"].Count;
        }

        let results = [];

        if ("ProjectMilestoneSession" in input["ShifamedMessage"]["ListOfProjectMilestoneSession"]) {
            for (let i = 0; i < input["ShifamedMessage"]["ListOfProjectMilestoneSession"]["ProjectMilestoneSession"].length; i++) {
                let projectMilestoneSession = input["ShifamedMessage"]["ListOfProjectMilestoneSession"]["ProjectMilestoneSession"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = projectMilestoneSession.USID;
                row.EmployeeUSID = projectMilestoneSession.EmployeeUSID;
                row.UserAgent = projectMilestoneSession.UserAgent;
                row.IPAddress = projectMilestoneSession.IPAddress;
                row.NumberOfAuditActions = projectMilestoneSession.NumberOfAuditActions;
                row.CreatedDatetime = projectMilestoneSession.CreatedDatetime;
                row.LastModifiedDatetime = projectMilestoneSession.LastModifiedDatetime;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }
    return output;
};

export const V1ProjectMilestoneAuditHistoryIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"] && input.ShifamedMessage["ListOfProjectMilestoneSession"] !== undefined) {
        if (input.ShifamedMessage["ListOfProjectMilestoneSession"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfProjectMilestoneSession"].Count;
        }

        let results: any[] = [];

        if ("ProjectMilestoneSession" in input.ShifamedMessage["ListOfProjectMilestoneSession"]) {
            for (let i = 0; i < input.ShifamedMessage["ListOfProjectMilestoneSession"]["ProjectMilestoneSession"].length; i++) {
                let projectMilestoneSession = input.ShifamedMessage["ListOfProjectMilestoneSession"]["ProjectMilestoneSession"][i];

                for (let j = 0; j < projectMilestoneSession["ListOfProjectMilestoneAuditHistory"]["ProjectMilestoneAuditHistory"].length; j++) {
                    let projectMilestoneAuditHistory: any = projectMilestoneSession["ListOfProjectMilestoneAuditHistory"]["ProjectMilestoneAuditHistory"][j];

                    let row: any = {};

                    let unordered = JSON.parse(atob(projectMilestoneAuditHistory.Change));
                    const ordered = Object.keys(unordered).sort().reduce(
                        (obj: any, key: string) => {
                            obj[key] = unordered[key];
                            return obj;
                        },
                        {}
                    );

                    row.RowSelected = false;
                    row.USID = projectMilestoneAuditHistory.USID;
                    row.ModificationType = projectMilestoneAuditHistory.ModificationType;
                    row.SerialNumberUSID = projectMilestoneAuditHistory.SerialNumberUSID;
                    row.SessionIdentifier = projectMilestoneAuditHistory.SessionIdentifier;
                    row.ProjectPlanUSID = projectMilestoneAuditHistory.ProjectPlanUSID;
                    row.ProjectPlanName = projectMilestoneAuditHistory.ProjectPlanName;
                    row.ProjectPlanPhaseUSID = projectMilestoneAuditHistory.ProjectPlanPhaseUSID;
                    row.ProjectPlanPhaseName = projectMilestoneAuditHistory.ProjectPlanPhaseName;
                    row.ProjectPlanPhaseMilestoneUSID = projectMilestoneAuditHistory.ProjectPlanPhaseMilestoneUSID;
                    row.ProjectPlanPhaseMilestoneName = projectMilestoneAuditHistory.ProjectPlanPhaseMilestoneName;
                    row.ProjectPlanPhaseMilestoneReferenceUSID = projectMilestoneAuditHistory.ProjectPlanPhaseMilestoneReferenceUSID;
                    row.Change = ordered;
                    row.CreatedByUSID = projectMilestoneAuditHistory.CreatedByUSID;
                    row.CreatedByName = projectMilestoneAuditHistory.CreatedByName;
                    row.CreatedByEmail = projectMilestoneAuditHistory.CreatedByEmail;
                    row.CreatedDatetime = projectMilestoneAuditHistory.CreatedDatetime;
                    row.LastModifiedDatetime = projectMilestoneAuditHistory.LastModifiedDatetime;
                    row.Action = null;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (projectMilestoneSession["ListOfProjectMilestoneAuditHistory"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = projectMilestoneSession["ListOfProjectMilestoneAuditHistory"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1ProjectPlanPhaseIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"] && input.ShifamedMessage["ListOfProjectPlanPhase"] !== undefined) {
        if (input.ShifamedMessage["ListOfProjectPlanPhase"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfProjectPlanPhase"].Count;
        }

        let results = [];

        if ("ProjectPlanPhase" in input["ShifamedMessage"]["ListOfProjectPlanPhase"]) {
            for (let i = 0; i < input["ShifamedMessage"]["ListOfProjectPlanPhase"]["ProjectPlanPhase"].length; i++) {
                let projectPlanPhase = input["ShifamedMessage"]["ListOfProjectPlanPhase"]["ProjectPlanPhase"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = projectPlanPhase.USID;
                row.ProjectPlanUSID = projectPlanPhase.ProjectPlanUSID;
                row.Name = projectPlanPhase.Name;
                row.Description = projectPlanPhase.Description;
                row.Status = projectPlanPhase.Status;
                row.StartDatetime = projectPlanPhase.StartDatetime;
                row.DueDatetime = projectPlanPhase.DueDatetime;
                row.Notes = projectPlanPhase.Notes;
                row.Justification = projectPlanPhase.Justification;
                row.PhaseToCopyUSID = null;
                row.PhaseToCopyNewName = null;
                row.NumberOfMilestonesInInProgressStatus = projectPlanPhase.NumberOfMilestonesInInProgressStatus;
                row.NumberOfMilestonesInDoneStatus = projectPlanPhase.NumberOfMilestonesInDoneStatus;
                row.CreatedDatetime = projectPlanPhase.CreatedDatetime;
                row.LastModifiedDatetime = projectPlanPhase.LastModifiedDatetime;

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1ProjectPlanPhaseMilestoneIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"] && input.ShifamedMessage["ListOfProjectPlanPhaseMilestone"] !== undefined) {
        if (input.ShifamedMessage["ListOfProjectPlanPhaseMilestone"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfProjectPlanPhaseMilestone"].Count;
        }

        let results = [];

        if ("ProjectPlanPhaseMilestone" in input["ShifamedMessage"]["ListOfProjectPlanPhaseMilestone"]) {
            for (let i = 0; i < input["ShifamedMessage"]["ListOfProjectPlanPhaseMilestone"]["ProjectPlanPhaseMilestone"].length; i++) {
                let projectPlanPhaseMilestone = input["ShifamedMessage"]["ListOfProjectPlanPhaseMilestone"]["ProjectPlanPhaseMilestone"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = projectPlanPhaseMilestone.USID;
                row.ProjectPlanPhaseUSID = projectPlanPhaseMilestone.ProjectPlanPhaseUSID;
                row.ProjectPlanPhaseStatus = projectPlanPhaseMilestone.ProjectPlanPhaseStatus;
                row.ProjectPlanPhaseName = projectPlanPhaseMilestone.ProjectPlanPhaseName;
                row.Name = projectPlanPhaseMilestone.Name;
                row.Description = projectPlanPhaseMilestone.Description;
                row.Status = projectPlanPhaseMilestone.Status;
                row.StartDatetime = projectPlanPhaseMilestone.StartDatetime;
                row.DueDatetime = projectPlanPhaseMilestone.DueDatetime;
                row.Notes = projectPlanPhaseMilestone.Notes;
                row.MilestoneToCopyUSID = null;
                row.MilestoneToCopyNewName = null;
                row.CreatedDatetime = projectPlanPhaseMilestone.CreatedDatetime;
                row.LastModifiedDatetime = projectPlanPhaseMilestone.LastModifiedDatetime;

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1ProjectPlanPhaseApprovalIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"] && input.ShifamedMessage["ListOfProjectPlanPhaseApproval"] !== undefined) {
        if (input.ShifamedMessage["ListOfProjectPlanPhaseApproval"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfProjectPlanPhaseApproval"].Count;
        }

        let results = [];

        if ("ProjectPlanPhaseApproval" in input["ShifamedMessage"]["ListOfProjectPlanPhaseApproval"]) {
            for (let i = 0; i < input["ShifamedMessage"]["ListOfProjectPlanPhaseApproval"]["ProjectPlanPhaseApproval"].length; i++) {
                let projectPlanPhaseApproval = input["ShifamedMessage"]["ListOfProjectPlanPhaseApproval"]["ProjectPlanPhaseApproval"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = projectPlanPhaseApproval.USID;
                row.ProjectPlanPhaseUSID = projectPlanPhaseApproval.ProjectPlanPhaseUSID;
                row.ProjectPlanPhaseStatus = projectPlanPhaseApproval.ProjectPlanPhaseStatus;
                row.Status = projectPlanPhaseApproval.Status;
                row.SubmissionDatetime = projectPlanPhaseApproval.SubmissionDatetime;
                row.ApprovalDatetime = projectPlanPhaseApproval.ApprovalDatetime;
                row.EmployeeUSID = projectPlanPhaseApproval.EmployeeUSID;
                row.EmployeeUserName = projectPlanPhaseApproval.EmployeeUserName;
                row.EmployeeUserEmail = projectPlanPhaseApproval.EmployeeUserEmail;
                row.CreatedDatetime = projectPlanPhaseApproval.CreatedDatetime;
                row.LastModifiedDatetime = projectPlanPhaseApproval.LastModifiedDatetime;
                row.Submit = false;
                row.Withdraw = false;

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1ProjectPlanPhaseMilestoneReferenceIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"] && input.ShifamedMessage["ListOfProjectPlanPhaseMilestoneReference"] !== undefined) {
        if (input.ShifamedMessage["ListOfProjectPlanPhaseMilestoneReference"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfProjectPlanPhaseMilestoneReference"].Count;
        }

        let results = [];

        if ("ProjectPlanPhaseMilestoneReference" in input["ShifamedMessage"]["ListOfProjectPlanPhaseMilestoneReference"]) {
            for (let i = 0; i < input["ShifamedMessage"]["ListOfProjectPlanPhaseMilestoneReference"]["ProjectPlanPhaseMilestoneReference"].length; i++) {
                let projectPlanPhaseMilestoneReference = input["ShifamedMessage"]["ListOfProjectPlanPhaseMilestoneReference"]["ProjectPlanPhaseMilestoneReference"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = projectPlanPhaseMilestoneReference.USID;
                row.ProjectPlanPhaseMilestoneUSID = projectPlanPhaseMilestoneReference.ProjectPlanPhaseMilestoneUSID;
                row.MilestoneName = projectPlanPhaseMilestoneReference.MilestoneName;
                row.MilestoneStatus = projectPlanPhaseMilestoneReference.MilestoneStatus;
                row.PhaseStatus = projectPlanPhaseMilestoneReference.PhaseStatus;
                row.ReferenceType = projectPlanPhaseMilestoneReference.ReferenceType;
                row.DocumentRevisionUSID = projectPlanPhaseMilestoneReference.DocumentRevisionUSID;
                row.DocumentID = projectPlanPhaseMilestoneReference.DocumentID;
                row.DocumentUSID = projectPlanPhaseMilestoneReference.DocumentUSID;
                row.DocumentTypeGroup = projectPlanPhaseMilestoneReference.DocumentTypeGroup;
                row.Name = projectPlanPhaseMilestoneReference.Name;
                row.Status = projectPlanPhaseMilestoneReference.Status;
                row.DisplayStatus = projectPlanPhaseMilestoneReference.DisplayStatus;
                row.DisplayRevision = projectPlanPhaseMilestoneReference.DisplayRevision;
                row.DocumentIDPlusRevision = projectPlanPhaseMilestoneReference.DocumentIDPlusRevision;
                row.ApprovalRequestUSID = projectPlanPhaseMilestoneReference.ApprovalRequestUSID;
                row.ApprovalRequestID = projectPlanPhaseMilestoneReference.ApprovalRequestID;
                row.ReleasedAt = projectPlanPhaseMilestoneReference.ReleasedAt;
                row.Comment = projectPlanPhaseMilestoneReference.Comment;
                row.PurchaseOrderStatus = projectPlanPhaseMilestoneReference.PurchaseOrderStatus;
                row.EquipmentStatus = projectPlanPhaseMilestoneReference.EquipmentStatus;
                row.LotStatus = projectPlanPhaseMilestoneReference.LotStatus;
                row.SearchableContent = projectPlanPhaseMilestoneReference.SearchableContent;
                row.CreatedDatetime = projectPlanPhaseMilestoneReference.CreatedDatetime;
                row.LastModifiedDatetime = projectPlanPhaseMilestoneReference.LastModifiedDatetime;

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1ProjectPlanPhaseAttachmentIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"] && input.ShifamedMessage["ListOfProjectPlanPhaseAttachment"] !== undefined) {
        if (input.ShifamedMessage["ListOfProjectPlanPhaseAttachment"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfProjectPlanPhaseAttachment"].Count;
        }

        let results = [];

        if ("ProjectPlanPhaseAttachment" in input["ShifamedMessage"]["ListOfProjectPlanPhaseAttachment"]) {
            for (let i = 0; i < input["ShifamedMessage"]["ListOfProjectPlanPhaseAttachment"]["ProjectPlanPhaseAttachment"].length; i++) {
                let projectPlanPhaseAttachment = input["ShifamedMessage"]["ListOfProjectPlanPhaseAttachment"]["ProjectPlanPhaseAttachment"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = projectPlanPhaseAttachment.USID;
                row.ProjectPlanPhaseUSID = projectPlanPhaseAttachment.ProjectPlanPhaseUSID;
                row.Name = projectPlanPhaseAttachment.Name;
                row.FileSize = projectPlanPhaseAttachment.FileSize;
                row.Type = projectPlanPhaseAttachment.Type;
                row.OwnerUserName = projectPlanPhaseAttachment.OwnerUserName;
                row.CreatedDatetime = projectPlanPhaseAttachment.CreatedDatetime;
                row.LastModifiedDatetime = projectPlanPhaseAttachment.LastModifiedDatetime;

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1EmployeeIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"] && input["ShifamedMessage"]["ListOfEmployee"] !== undefined) {
        if (input["ShifamedMessage"]["ListOfEmployee"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["ShifamedMessage"]["ListOfEmployee"].Count;
        }

        let results = [];

        if ("Employee" in input["ShifamedMessage"]["ListOfEmployee"]) {
            for (let i = 0; i < input["ShifamedMessage"]["ListOfEmployee"]["Employee"].length; i++) {
                let employee = input["ShifamedMessage"]["ListOfEmployee"]["Employee"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = employee.USID;
                row.UserUSID = employee.UserUSID;
                row.Email = employee.Email;
                row.UserName = employee.UserName;
                row.Confirmed = employee.Confirmed;
                row.Locked = employee.Locked;
                row.Active = employee.Active;
                row.SlackUserID = employee.SlackUserID;
                row.CreatedDatetime = employee.CreatedDatetime;
                row.LastModifiedDatetime = employee.LastModifiedDatetime;
                row.Action = null;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }
    return output;
};

export const V1AdminPositionMembershipIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"] && input["ShifamedMessage"] && input["ShifamedMessage"]["ListOfAdminPositionMembership"] !== undefined) {
        if (input["ShifamedMessage"]["ListOfAdminPositionMembership"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["ShifamedMessage"]["ListOfAdminPositionMembership"].Count;
        }

        let results = [];

        if ("AdminPositionMembership" in input["ShifamedMessage"]["ListOfAdminPositionMembership"]) {
            for (let i = 0; i < input["ShifamedMessage"]["ListOfAdminPositionMembership"]["AdminPositionMembership"].length; i++) {
                let adminPositionMembership = input["ShifamedMessage"]["ListOfAdminPositionMembership"]["AdminPositionMembership"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = adminPositionMembership.USID;
                row.SourceUSID = adminPositionMembership.SourceUSID;
                row.SourceType = adminPositionMembership.SourceType;
                row.PositionUSID = adminPositionMembership.PositionUSID;
                row.PositionName = adminPositionMembership.PositionName;
                row.PrimaryEmployeeUSID = adminPositionMembership.PrimaryEmployeeUSID;
                row.PrimaryEmployeeName = adminPositionMembership.PrimaryEmployeeName;
                row.Employees = adminPositionMembership.AdminPosition.ListOfEmployee.Employee;
                row.Realm = adminPositionMembership.Realm;
                row.CreatedDatetime = adminPositionMembership.CreatedDatetime;
                row.LastModifiedDatetime = adminPositionMembership.LastModifiedDatetime;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }
    return output;
};

export const V1AdminUserGroupMembershipIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"] && input["ShifamedMessage"] && input["ShifamedMessage"]["ListOfAdminUserGroupMembership"] !== undefined) {
        if (input["ShifamedMessage"]["ListOfAdminUserGroupMembership"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["ShifamedMessage"]["ListOfAdminUserGroupMembership"].Count;
        }

        let results = [];

        if ("AdminUserGroupMembership" in input["ShifamedMessage"]["ListOfAdminUserGroupMembership"]) {
            for (let i = 0; i < input["ShifamedMessage"]["ListOfAdminUserGroupMembership"]["AdminUserGroupMembership"].length; i++) {
                let adminUserGroupMembership = input["ShifamedMessage"]["ListOfAdminUserGroupMembership"]["AdminUserGroupMembership"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = adminUserGroupMembership.USID;
                row.SourceUSID = adminUserGroupMembership.SourceUSID;
                row.SourceType = adminUserGroupMembership.SourceType;
                row.UserGroupUSID = adminUserGroupMembership.UserGroupUSID;
                row.UserGroupName = adminUserGroupMembership.UserGroupName;
                row.PrimaryEmployeeUSID = adminUserGroupMembership.PrimaryEmployeeUSID;
                row.PrimaryEmployeeName = adminUserGroupMembership.PrimaryEmployeeName;
                row.Employees = adminUserGroupMembership.ListOfEmployee.Employee;
                row.Realm = adminUserGroupMembership.Realm;
                row.CreatedDatetime = adminUserGroupMembership.CreatedDatetime;
                row.LastModifiedDatetime = adminUserGroupMembership.LastModifiedDatetime;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }
    return output;
};

export const V1AdminWorkGroupMembershipIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"] && input["ShifamedMessage"] && input["ShifamedMessage"]["ListOfAdminWorkGroupMembership"] !== undefined) {
        if (input["ShifamedMessage"]["ListOfAdminWorkGroupMembership"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["ShifamedMessage"]["ListOfAdminWorkGroupMembership"].Count;
        }

        let results = [];

        if ("AdminWorkGroupMembership" in input["ShifamedMessage"]["ListOfAdminWorkGroupMembership"]) {
            for (let i = 0; i < input["ShifamedMessage"]["ListOfAdminWorkGroupMembership"]["AdminWorkGroupMembership"].length; i++) {
                let adminWorkGroupMembership = input["ShifamedMessage"]["ListOfAdminWorkGroupMembership"]["AdminWorkGroupMembership"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = adminWorkGroupMembership.USID;
                row.SourceUSID = adminWorkGroupMembership.SourceUSID;
                row.SourceType = adminWorkGroupMembership.SourceType;
                row.AdminWorkGroup = adminWorkGroupMembership.AdminWorkGroup;
                row.WorkGroupUSID = adminWorkGroupMembership.WorkGroupUSID;
                row.WorkGroupName = adminWorkGroupMembership.WorkGroupName;
                row.PrimaryEmployeeUSID = adminWorkGroupMembership.PrimaryEmployeeUSID;
                row.PrimaryEmployeeName = adminWorkGroupMembership.PrimaryEmployeeName;
                row.Realm = adminWorkGroupMembership.Realm;
                row.CreatedDatetime = adminWorkGroupMembership.CreatedDatetime;
                row.LastModifiedDatetime = adminWorkGroupMembership.LastModifiedDatetime;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }
    return output;
};

export const V1AdminOrganizationIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"] && input["ShifamedMessage"] && input.ShifamedMessage["ListOfAdminOrganization"] !== undefined) {
        if (input.ShifamedMessage["ListOfAdminOrganization"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfAdminOrganization"].Count;
        }

        let results: any[] = [];

        if ("AdminOrganization" in input.ShifamedMessage["ListOfAdminOrganization"]) {
            for (let i = 0; i < input.ShifamedMessage["ListOfAdminOrganization"]["AdminOrganization"].length; i++) {
                let organization = input.ShifamedMessage["ListOfAdminOrganization"]["AdminOrganization"][i];
                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = organization.USID;
                row.ParentUSID = organization.ParentUSID;
                row.ParentOrganizationName = organization.ParentOrganizationName;
                row.OrganizationType = organization.OrganizationType;
                row.Name = organization.Name;
                row.Status = organization.Status;

                row.CreatedDatetime = organization.CreatedDatetime;
                row.LastModifiedDatetime = organization.LastModifiedDatetime;
                row.Keyword = organization.Keyword;
                row.Realm = organization.Realm;

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }

    return output;
};

export const V1AdminOrganizationPositionIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"] && input.ShifamedMessage["ListOfAdminOrganization"] !== undefined) {
        if (input.ShifamedMessage["ListOfAdminOrganization"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfAdminOrganization"].Count;
        }

        let results: any[] = [];

        if ("AdminOrganization" in input.ShifamedMessage["ListOfAdminOrganization"]) {
            for (let i = 0; i < input.ShifamedMessage["ListOfAdminOrganization"]["AdminOrganization"].length; i++) {
                let organization = input.ShifamedMessage["ListOfAdminOrganization"]["AdminOrganization"][i];

                for (let j = 0; j < organization["ListOfAdminPosition"]["AdminPosition"].length; j++) {
                    let position: any = organization["ListOfAdminPosition"]["AdminPosition"][j];

                    let row: any = {};

                    row.RowSelected = false;
                    row.USID = position.USID;
                    row.ParentUSID = position.ParentUSID;
                    row.ParentPositionName = position.ParentPositionName;
                    row.PrimaryEmployeeUSID = position.PrimaryEmployeeUSID;
                    row.PrimaryEmployeeName = position.PrimaryEmployeeName;
                    row.OrganizationUSID = position.OrganizationUSID;
                    row.OrganizationName = position.OrganizationName;
                    row.Name = position.Name;
                    row.CreatedDatetime = position.CreatedDatetime;
                    row.LastModifiedDatetime = position.LastModifiedDatetime;
                    row.Action = null;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (organization["ListOfAdminPosition"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = organization["ListOfAdminPosition"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1AdminPositionIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"] && input.ShifamedMessage["ListOfAdminPosition"] !== undefined) {
        if (input.ShifamedMessage["ListOfAdminPosition"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfAdminPosition"].Count;
        }

        let results: any[] = [];

        if ("AdminPosition" in input.ShifamedMessage["ListOfAdminPosition"]) {
            for (let i = 0; i < input.ShifamedMessage["ListOfAdminPosition"]["AdminPosition"].length; i++) {
                let position = input.ShifamedMessage["ListOfAdminPosition"]["AdminPosition"][i];
                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = position.USID;
                row.ParentUSID = position.ParentUSID;
                row.ParentPositionName = position.ParentPositionName;
                row.PrimaryEmployeeUSID = position.PrimaryEmployeeUSID;
                row.PrimaryEmployeeName = position.PrimaryEmployeeName;
                row.OrganizationUSID = position.OrganizationUSID;
                row.OrganizationName = position.OrganizationName;
                row.Name = position.Name;
                row.Status = position.Status;

                row.CreatedDatetime = position.CreatedDatetime;
                row.LastModifiedDatetime = position.LastModifiedDatetime;
                row.Keyword = position.Keyword;
                row.Realm = position.Realm;

                row.ListOfEmployee = {
                    Employee: []
                };

                if ("ListOfEmployee" in position) {
                    for (let j = 0; j < position["ListOfEmployee"]["Employee"].length; j++) {
                        let employee: any = position["ListOfEmployee"]["Employee"][j];

                        let employee_row: any = {};

                        employee_row.RowSelected = false;
                        employee_row.USID = employee.USID;
                        employee_row.UserUSID = employee.UserUSID;
                        employee_row.Email = employee.Email;
                        employee_row.UserName = employee.UserName;
                        employee_row.Confirmed = employee.Confirmed;
                        employee_row.Locked = employee.Locked;
                        employee_row.Active = employee.Active;
                        employee_row.SlackUserID = employee.SlackUserID;
                        employee_row.CreatedDatetime = employee.CreatedDatetime;
                        employee_row.LastModifiedDatetime = employee.LastModifiedDatetime;
                        employee_row.Action = null;

                        row.ListOfEmployee.Employee.push(employee_row);
                    }
                }
                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1AdminPositionEmployeeIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"] && input.ShifamedMessage["ListOfAdminPosition"] !== undefined) {
        if (input.ShifamedMessage["ListOfAdminPosition"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfAdminPosition"].Count;
        }

        let results: any[] = [];

        if ("AdminPosition" in input.ShifamedMessage["ListOfAdminPosition"]) {
            for (let i = 0; i < input.ShifamedMessage["ListOfAdminPosition"]["AdminPosition"].length; i++) {
                let position = input.ShifamedMessage["ListOfAdminPosition"]["AdminPosition"][i];

                for (let j = 0; j < position["ListOfEmployee"]["Employee"].length; j++) {
                    let employee: any = position["ListOfEmployee"]["Employee"][j];

                    let row: any = {};

                    row.RowSelected = false;
                    row.USID = employee.USID;
                    row.UserUSID = employee.UserUSID;
                    row.Email = employee.Email;
                    row.UserName = employee.UserName;
                    row.Confirmed = employee.Confirmed;
                    row.Locked = employee.Locked;
                    row.Active = employee.Active;
                    row.SlackUserID = employee.SlackUserID;
                    row.CreatedDatetime = employee.CreatedDatetime;
                    row.LastModifiedDatetime = employee.LastModifiedDatetime;
                    row.Action = null;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (position["ListOfEmployee"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = position["ListOfEmployee"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1AdminPrivilegeIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"] && input.ShifamedMessage["ListOfAdminPrivilege"] !== undefined) {
        if (input.ShifamedMessage["ListOfAdminPrivilege"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfAdminPrivilege"].Count;
        }

        let results: any[] = [];

        if ("AdminPrivilege" in input.ShifamedMessage["ListOfAdminPrivilege"]) {
            for (let i = 0; i < input.ShifamedMessage["ListOfAdminPrivilege"]["AdminPrivilege"].length; i++) {
                let privilege = input.ShifamedMessage["ListOfAdminPrivilege"]["AdminPrivilege"][i];

                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = privilege.USID;
                row.Name = privilege.Name;

                row.ListOfGroup = privilege.ListOfGroup;
                row.CreatedDatetime = privilege.CreatedDatetime;
                row.LastModifiedDatetime = privilege.LastModifiedDatetime;
                row.Keyword = privilege.Keyword;
                row.Realm = privilege.Realm;

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1AdminUserGroupIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"] && input.ShifamedMessage["ListOfAdminUserGroup"] !== undefined) {
        if (input.ShifamedMessage["ListOfAdminUserGroup"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfAdminUserGroup"].Count;
        }

        let results: any[] = [];

        if ("AdminUserGroup" in input.ShifamedMessage["ListOfAdminUserGroup"]) {
            for (let i = 0; i < input.ShifamedMessage["ListOfAdminUserGroup"]["AdminUserGroup"].length; i++) {
                let user_group = input.ShifamedMessage["ListOfAdminUserGroup"]["AdminUserGroup"][i];
                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = user_group.USID;
                row.PrimaryEmployeeUSID = user_group.PrimaryEmployeeUSID;
                row.PrimaryEmployeeName = user_group.PrimaryEmployeeName;
                row.Name = user_group.Name;
                row.Status = user_group.Status;

                row.CreatedDatetime = user_group.CreatedDatetime;
                row.LastModifiedDatetime = user_group.LastModifiedDatetime;
                row.Keyword = user_group.Keyword;
                row.Realm = user_group.Realm;

                row.ListOfEmployee = {
                    Employee: []
                };

                if ("ListOfEmployee" in user_group) {
                    for (let j = 0; j < user_group["ListOfEmployee"]["Employee"].length; j++) {
                        let employee: any = user_group["ListOfEmployee"]["Employee"][j];

                        let employee_row: any = {};

                        employee_row.RowSelected = false;
                        employee_row.USID = employee.USID;
                        employee_row.UserUSID = employee.UserUSID;
                        employee_row.Email = employee.Email;
                        employee_row.UserName = employee.UserName;
                        employee_row.Confirmed = employee.Confirmed;
                        employee_row.Locked = employee.Locked;
                        employee_row.Active = employee.Active;
                        employee_row.SlackUserID = employee.SlackUserID;
                        employee_row.CreatedDatetime = employee.CreatedDatetime;
                        employee_row.LastModifiedDatetime = employee.LastModifiedDatetime;
                        employee_row.Action = null;

                        row.ListOfEmployee.Employee.push(employee_row);
                    }
                }

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1AdminUserGroupEmployeeIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"] && input.ShifamedMessage["ListOfAdminUserGroup"] !== undefined) {
        if (input.ShifamedMessage["ListOfAdminUserGroup"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfAdminUserGroup"].Count;
        }

        let results: any[] = [];

        if ("AdminUserGroup" in input.ShifamedMessage["ListOfAdminUserGroup"]) {
            for (let i = 0; i < input.ShifamedMessage["ListOfAdminUserGroup"]["AdminUserGroup"].length; i++) {
                let user_group = input.ShifamedMessage["ListOfAdminUserGroup"]["AdminUserGroup"][i];

                for (let j = 0; j < user_group["ListOfEmployee"]["Employee"].length; j++) {
                    let employee: any = user_group["ListOfEmployee"]["Employee"][j];

                    let row: any = {};

                    row.RowSelected = false;
                    row.USID = employee.USID;
                    row.UserUSID = employee.UserUSID;
                    row.Email = employee.Email;
                    row.UserName = employee.UserName;
                    row.Confirmed = employee.Confirmed;
                    row.Locked = employee.Locked;
                    row.Active = employee.Active;
                    row.SlackUserID = employee.SlackUserID;
                    row.CreatedDatetime = employee.CreatedDatetime;
                    row.LastModifiedDatetime = employee.LastModifiedDatetime;
                    row.Action = null;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (user_group["ListOfEmployee"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = user_group["ListOfEmployee"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1AdminWorkGroupIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"] && input.ShifamedMessage["ListOfAdminWorkGroup"] !== undefined) {
        if (input.ShifamedMessage["ListOfAdminWorkGroup"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfAdminWorkGroup"].Count;
        }

        let results: any[] = [];

        if ("AdminWorkGroup" in input.ShifamedMessage["ListOfAdminWorkGroup"]) {
            for (let i = 0; i < input.ShifamedMessage["ListOfAdminWorkGroup"]["AdminWorkGroup"].length; i++) {
                let work_group = input.ShifamedMessage["ListOfAdminWorkGroup"]["AdminWorkGroup"][i];
                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = work_group.USID;
                row.PrimaryEmployeeUSID = work_group.PrimaryEmployeeUSID;
                row.PrimaryEmployeeName = work_group.PrimaryEmployeeName;
                row.Name = work_group.Name;
                row.Status = work_group.Status;

                row.CreatedDatetime = work_group.CreatedDatetime;
                row.LastModifiedDatetime = work_group.LastModifiedDatetime;
                row.Keyword = work_group.Keyword;
                row.Realm = work_group.Realm;

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1AdminWorkGroupEmployeeIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"] && input.ShifamedMessage["ListOfAdminWorkGroup"] !== undefined) {
        if (input.ShifamedMessage["ListOfAdminWorkGroup"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfAdminWorkGroup"].Count;
        }

        let results: any[] = [];

        if ("AdminWorkGroup" in input.ShifamedMessage["ListOfAdminWorkGroup"]) {
            for (let i = 0; i < input.ShifamedMessage["ListOfAdminWorkGroup"]["AdminWorkGroup"].length; i++) {
                let work_group = input.ShifamedMessage["ListOfAdminWorkGroup"]["AdminWorkGroup"][i];

                for (let j = 0; j < work_group["ListOfWorkGroupEmployee"]["WorkGroupEmployee"].length; j++) {
                    let employee: any = work_group["ListOfWorkGroupEmployee"]["WorkGroupEmployee"][j];

                    let row: any = {};

                    row.RowSelected = false;
                    row.USID = employee.USID;
                    row.UserUSID = employee.UserUSID;
                    row.Email = employee.Email;
                    row.UserName = employee.UserName;
                    row.Confirmed = employee.Confirmed;
                    row.Locked = employee.Locked;
                    row.Active = employee.Active;
                    row.SlackUserID = employee.SlackUserID;
                    row.CreatedDatetime = employee.CreatedDatetime;
                    row.LastModifiedDatetime = employee.LastModifiedDatetime;
                    row.Action = null;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (work_group["ListOfWorkGroupEmployee"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = work_group["ListOfWorkGroupEmployee"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1AdminWorkGroupOrganizationIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"] && input.ShifamedMessage["ListOfAdminWorkGroup"] !== undefined) {
        if (input.ShifamedMessage["ListOfAdminWorkGroup"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfAdminWorkGroup"].Count;
        }

        let results: any[] = [];

        if ("AdminWorkGroup" in input.ShifamedMessage["ListOfAdminWorkGroup"]) {
            for (let i = 0; i < input.ShifamedMessage["ListOfAdminWorkGroup"]["AdminWorkGroup"].length; i++) {
                let work_group = input.ShifamedMessage["ListOfAdminWorkGroup"]["AdminWorkGroup"][i];

                for (let j = 0; j < work_group["ListOfAdminOrganization"]["AdminOrganization"].length; j++) {
                    let organization: any = work_group["ListOfAdminOrganization"]["AdminOrganization"][j];

                    let row: any = {};

                    row.RowSelected = false;
                    row.USID = organization.USID;
                    row.Realm = organization.Realm;
                    row.ParentUSID = organization.ParentUSID;
                    row.ParentOrganizationName = organization.ParentOrganizationName;
                    row.OrganizationType = organization.OrganizationType;
                    row.Name = organization.Name;
                    row.CreatedDatetime = organization.CreatedDatetime;
                    row.LastModifiedDatetime = organization.LastModifiedDatetime;
                    row.Action = null;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (work_group["ListOfAdminOrganization"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = work_group["ListOfAdminOrganization"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1AdminWorkGroupPositionIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"] && input.ShifamedMessage["ListOfAdminWorkGroup"] !== undefined) {
        if (input.ShifamedMessage["ListOfAdminWorkGroup"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfAdminWorkGroup"].Count;
        }

        let results: any[] = [];

        if ("AdminWorkGroup" in input.ShifamedMessage["ListOfAdminWorkGroup"]) {
            for (let i = 0; i < input.ShifamedMessage["ListOfAdminWorkGroup"]["AdminWorkGroup"].length; i++) {
                let work_group = input.ShifamedMessage["ListOfAdminWorkGroup"]["AdminWorkGroup"][i];

                for (let j = 0; j < work_group["ListOfAdminPosition"]["AdminPosition"].length; j++) {
                    let position: any = work_group["ListOfAdminPosition"]["AdminPosition"][j];

                    let row: any = {};

                    row.RowSelected = false;
                    row.USID = position.USID;
                    row.Realm = position.Realm;
                    row.ParentUSID = position.ParentUSID;
                    row.ParentPositionName = position.ParentPositionName;
                    row.PrimaryEmployeeUSID = position.PrimaryEmployeeUSID;
                    row.PrimaryEmployeeName = position.PrimaryEmployeeName;
                    row.OrganizationUSID = position.OrganizationUSID;
                    row.OrganizationName = position.OrganizationName;
                    row.Name = position.Name;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (work_group["ListOfAdminPosition"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = work_group["ListOfAdminPosition"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1AdminWorkGroupUserGroupIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"] && input.ShifamedMessage["ListOfAdminWorkGroup"] !== undefined) {
        if (input.ShifamedMessage["ListOfAdminWorkGroup"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfAdminWorkGroup"].Count;
        }

        let results: any[] = [];

        if ("AdminWorkGroup" in input.ShifamedMessage["ListOfAdminWorkGroup"]) {
            for (let i = 0; i < input.ShifamedMessage["ListOfAdminWorkGroup"]["AdminWorkGroup"].length; i++) {
                let work_group = input.ShifamedMessage["ListOfAdminWorkGroup"]["AdminWorkGroup"][i];

                for (let j = 0; j < work_group["ListOfAdminUserGroup"]["AdminUserGroup"].length; j++) {
                    let userGroup: any = work_group["ListOfAdminUserGroup"]["AdminUserGroup"][j];

                    let row: any = {};

                    row.RowSelected = false;
                    row.USID = userGroup.USID;
                    row.Realm = userGroup.Realm;
                    row.PrimaryEmployeeUSID = userGroup.PrimaryEmployeeUSID;
                    row.PrimaryEmployeeName = userGroup.PrimaryEmployeeName;
                    row.Name = userGroup.Name;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (work_group["ListOfAdminUserGroup"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = work_group["ListOfAdminUserGroup"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1EmployeeAdminRoleIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"] && input.ShifamedMessage["ListOfEmployee"] !== undefined) {
        if (input.ShifamedMessage["ListOfEmployee"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfEmployee"].Count;
        }

        let results: any[] = [];

        if ("Employee" in input.ShifamedMessage["ListOfEmployee"]) {
            for (let i = 0; i < input.ShifamedMessage["ListOfEmployee"]["Employee"].length; i++) {
                let employee = input.ShifamedMessage["ListOfEmployee"]["Employee"][i];

                for (let j = 0; j < employee["ListOfAdminRole"]["AdminRole"].length; j++) {
                    let role: any = employee["ListOfAdminRole"]["AdminRole"][j];

                    let row: any = {};

                    row.RowNum = i;
                    row.RowSelected = false;

                    row.USID = role.USID;
                    row.ParentRoleUSID = role.ParentRoleUSID;
                    row.ParentRoleName = role.ParentRoleName;
                    row.Name = role.Name;
                    row.Status = role.Status;

                    row.CreatedDatetime = role.CreatedDatetime;
                    row.LastModifiedDatetime = role.LastModifiedDatetime;
                    row.Keyword = role.Keyword;
                    row.Realm = role.Realm;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (employee["ListOfAdminRole"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = employee["ListOfAdminRole"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1EmployeeAdminPositionIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"] && input.ShifamedMessage["ListOfEmployee"] !== undefined) {
        if (input.ShifamedMessage["ListOfEmployee"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfEmployee"].Count;
        }

        let results: any[] = [];

        if ("Employee" in input.ShifamedMessage["ListOfEmployee"]) {
            for (let i = 0; i < input.ShifamedMessage["ListOfEmployee"]["Employee"].length; i++) {
                let employee = input.ShifamedMessage["ListOfEmployee"]["Employee"][i];

                for (let j = 0; j < employee["ListOfAdminPosition"]["AdminPosition"].length; j++) {
                    let position: any = employee["ListOfAdminPosition"]["AdminPosition"][j];

                    let row: any = {};

                    row.RowNum = i;
                    row.RowSelected = false;

                    row.USID = position.USID;
                    row.ParentUSID = position.ParentUSID;
                    row.ParentPositionName = position.ParentPositionName;
                    row.Name = position.Name;
                    row.Status = position.Status;

                    row.CreatedDatetime = position.CreatedDatetime;
                    row.LastModifiedDatetime = position.LastModifiedDatetime;
                    row.Keyword = position.Keyword;
                    row.Realm = position.Realm;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (employee["ListOfAdminPosition"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = employee["ListOfAdminPosition"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1EmployeeAdminUserGroupIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"] && input.ShifamedMessage["ListOfEmployee"] !== undefined) {
        if (input.ShifamedMessage["ListOfEmployee"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfEmployee"].Count;
        }

        let results: any[] = [];

        if ("Employee" in input.ShifamedMessage["ListOfEmployee"]) {
            for (let i = 0; i < input.ShifamedMessage["ListOfEmployee"]["Employee"].length; i++) {
                let employee = input.ShifamedMessage["ListOfEmployee"]["Employee"][i];

                for (let j = 0; j < employee["ListOfAdminUserGroup"]["AdminUserGroup"].length; j++) {
                    let user_group: any = employee["ListOfAdminUserGroup"]["AdminUserGroup"][j];

                    let row: any = {};

                    row.RowNum = i;
                    row.RowSelected = false;

                    row.USID = user_group.USID;
                    row.PrimaryEmployeeUSID = user_group.PrimaryEmployeeUSID;
                    row.PrimaryEmployeeName = user_group.PrimaryEmployeeName;
                    row.Name = user_group.Name;
                    row.Status = user_group.Status;

                    row.CreatedDatetime = user_group.CreatedDatetime;
                    row.LastModifiedDatetime = user_group.LastModifiedDatetime;
                    row.Keyword = user_group.Keyword;
                    row.Realm = user_group.Realm;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (employee["ListOfAdminUserGroup"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = employee["ListOfAdminUserGroup"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1EmployeeAdminWorkGroupIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"] && input.ShifamedMessage["ListOfEmployee"] !== undefined) {
        if (input.ShifamedMessage["ListOfEmployee"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfEmployee"].Count;
        }

        let results: any[] = [];

        if ("Employee" in input.ShifamedMessage["ListOfEmployee"]) {
            for (let i = 0; i < input.ShifamedMessage["ListOfEmployee"]["Employee"].length; i++) {
                let employee = input.ShifamedMessage["ListOfEmployee"]["Employee"][i];

                for (let j = 0; j < employee["ListOfAdminWorkGroup"]["AdminWorkGroup"].length; j++) {
                    let work_group: any = employee["ListOfAdminWorkGroup"]["AdminWorkGroup"][j];

                    let row: any = {};

                    row.RowNum = i;
                    row.RowSelected = false;

                    row.USID = work_group.USID;
                    row.PrimaryEmployeeUSID = work_group.PrimaryEmployeeUSID;
                    row.PrimaryEmployeeName = work_group.PrimaryEmployeeName;
                    row.Name = work_group.Name;
                    row.Status = work_group.Status;

                    row.CreatedDatetime = work_group.CreatedDatetime;
                    row.LastModifiedDatetime = work_group.LastModifiedDatetime;
                    row.Keyword = work_group.Keyword;
                    row.Realm = work_group.Realm;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (employee["ListOfAdminWorkGroup"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = employee["ListOfAdminWorkGroup"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1SupplierRevisionIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"] && input.ShifamedMessage["ListOfSupplierRevision"] !== undefined) {
        if (input.ShifamedMessage["ListOfSupplierRevision"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfSupplierRevision"].Count;
        }

        let results: any[] = [];

        if ("SupplierRevision" in input.ShifamedMessage["ListOfSupplierRevision"]) {
            for (let i = 0; i < input.ShifamedMessage["ListOfSupplierRevision"]["SupplierRevision"].length; i++) {
                let document_revision = input.ShifamedMessage["ListOfSupplierRevision"]["SupplierRevision"][i];
                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = document_revision.USID;
                row.DocumentUSID = document_revision.DocumentUSID;
                row.DocumentID = document_revision.DocumentID;
                row.DocumentIDPlusRevision = document_revision.DocumentIDPlusRevision;
                row.DocumentTypeUSID = document_revision.DocumentTypeUSID;
                row.DocumentTypeGroup = document_revision.DocumentTypeGroup;
                row.DocumentTypeAcronym = document_revision.DocumentTypeAcronm;
                row.Version = document_revision.Version;
                row.Description = document_revision.Description;
                row.Name = document_revision.Name;
                row.Status = document_revision.Status;
                row.DisplayStatus = document_revision.DisplayStatus;
                row.ParentEquipmentUSID = document_revision.ParentEquipmentUSID;
                row.Revision = document_revision.Revision;
                row.RevisionStage = document_revision.RevisionStage;
                row.OwnerUSID = document_revision.OwnerUSID;
                row.OwnerUserUSID = document_revision.OwnerUserUSID;
                row.OwnerUserName = document_revision.OwnerUserName;
                row.ApprovalRequestUSID = document_revision.ApprovalRequestUSID;
                row.ApprovalRequestID = document_revision.ApprovalRequestID;
                row.RevisionChangeType = document_revision.RevisionChangeType;
                row.DeprecatedAt = document_revision.DeprecatedAt;
                row.ReleasedAt = document_revision.ReleasedAt;
                row.ObsoletedAt = document_revision.ObsoletedAt;
                row.Retrain = document_revision.Retrain;
                row.EnlilFormInput = document_revision.EnlilFormInput;
                row.FormDocumentRevisionUSID = document_revision.FormDocumentRevisionUSID;
                row.ExternalID = document_revision.ExternalID;
                row.RenderHTML = document_revision.RenderHTML;
                row.PDFUSID = document_revision.PDFUSID;
                row.SubRevision = document_revision.SubRevision;
                row.DisplayRevision = document_revision.DisplayRevision;
                row.PreCalc = document_revision.PreCalc;
                row.Schema = document_revision.Schema;
                row.EquipmentStatus = document_revision.EquipmentStatus;
                row.PurchaseOrderStatus = document_revision.PurchaseOrderStatus;
                row.LotStatus = document_revision.LotStatus;
                row.EffectiveDate = document_revision.EffectiveDate;
                row.PrimaryAttachmentUSID = document_revision.PrimaryAttachmentUSID;
                row.LastZipFileUpdate = document_revision.LastZipFileUpdate;
                row.ApprovedAt = document_revision.ApprovedAt;
                row.CreatedDatetime = document_revision.CreatedDatetime;
                row.LastModifiedDatetime = document_revision.LastModifiedDatetime;
                row.Keyword = document_revision.Keyword;
                row.Realm = document_revision.CompanyUSID;

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};
